"use strict";
/**
 * This is your main. This is where you re-export everything you want to be publicly available.
 *
 * The build enforces that the file has the same name as the global variable that is exported.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
const TableauAskData_1 = require("./EmbeddingApi/Components/TableauAskData");
const TableauAuthoringViz_1 = require("./EmbeddingApi/Components/TableauAuthoringViz");
const TableauPulse_1 = require("./EmbeddingApi/Components/TableauPulse");
const TableauViz_1 = require("./EmbeddingApi/Components/TableauViz");
const isAlpha = typeof VERSION_IS_ALPHA !== 'undefined' ? VERSION_IS_ALPHA : false;
api_shared_js_1.ApiVersion.SetVersionNumber(typeof API_VERSION_NUMBER !== 'undefined' ? API_VERSION_NUMBER : '0.0.0', isAlpha);
function defineCustomElement(name, elementClass) {
    if (typeof window === 'undefined') {
        return;
    }
    try {
        // Check if the element is already defined
        if (!window.customElements.get(name)) {
            window.customElements.define(name, elementClass);
        }
        else {
            console.warn(`Custom element '${name}' is already defined.`);
        }
    }
    catch (error) {
        console.error(`Error defining custom element '${name}':`, error);
    }
}
function isCustomElementsSupported() {
    if (typeof window === 'undefined') {
        return false;
    }
    return 'customElements' in window;
}
// Check for Custom Elements API support
if (isCustomElementsSupported()) {
    // Define all the custom elements here
    defineCustomElement('tableau-viz', TableauViz_1.TableauViz);
    defineCustomElement('tableau-authoring-viz', TableauAuthoringViz_1.TableauAuthoringViz);
    defineCustomElement('tableau-ask-data', TableauAskData_1.TableauAskData);
    defineCustomElement('tableau-pulse', TableauPulse_1.TableauPulse);
}
else {
    console.error('Custom Elements API is not supported in this browser.');
}
const ErrorCodes = Object.assign(Object.assign({}, api_external_contract_js_1.EmbeddingErrorCodes), api_external_contract_js_1.SharedErrorCodes);
exports.ErrorCodes = ErrorCodes;
// Export Enums & Interfaces
var api_external_contract_js_2 = require("@tableau/api-external-contract-js");
exports.AnalyticsObjectType = api_external_contract_js_2.AnalyticsObjectType;
exports.AnnotationType = api_external_contract_js_2.AnnotationType;
exports.ApiMenuType = api_external_contract_js_2.ApiMenuType;
exports.ClassNameKey = api_external_contract_js_2.ClassNameKey;
exports.ColumnType = api_external_contract_js_2.ColumnType;
exports.CrosstabFileFormat = api_external_contract_js_2.CrosstabFileFormat;
exports.DashboardLayoutChange = api_external_contract_js_2.DashboardLayoutChange;
exports.DashboardObjectType = api_external_contract_js_2.DashboardObjectType;
exports.DataType = api_external_contract_js_2.DataType;
exports.DateRangeType = api_external_contract_js_2.DateRangeType;
exports.DeviceType = api_external_contract_js_2.DeviceType;
exports.EmbeddedIframeAttributes = api_external_contract_js_2.EmbeddedIframeAttributes;
exports.EncodingType = api_external_contract_js_2.EncodingType;
exports.FieldAggregationType = api_external_contract_js_2.FieldAggregationType;
exports.FieldRoleType = api_external_contract_js_2.FieldRoleType;
exports.FileFormats = api_external_contract_js_2.FileFormats;
exports.FilterDomainType = api_external_contract_js_2.FilterDomainType;
exports.FilterNullOption = api_external_contract_js_2.FilterNullOption;
exports.FilterType = api_external_contract_js_2.FilterType;
exports.FilterUpdateType = api_external_contract_js_2.FilterUpdateType;
exports.HierarchicalLevelSelectionState = api_external_contract_js_2.HierarchicalLevelSelectionState;
exports.IncludeDataValuesOption = api_external_contract_js_2.IncludeDataValuesOption;
exports.MarkType = api_external_contract_js_2.MarkType;
exports.ParameterValueType = api_external_contract_js_2.ParameterValueType;
exports.PeriodType = api_external_contract_js_2.PeriodType;
exports.PrintOrientation = api_external_contract_js_2.PrintOrientation;
exports.PrintPageSize = api_external_contract_js_2.PrintPageSize;
exports.PrintScaling = api_external_contract_js_2.PrintScaling;
exports.PulseAttributes = api_external_contract_js_2.PulseAttributes;
exports.PulseErrorMessageVisibility = api_external_contract_js_2.PulseErrorMessageVisibility;
exports.PulseLayout = api_external_contract_js_2.PulseLayout;
exports.PulseTimeDimension = api_external_contract_js_2.PulseTimeDimension;
exports.QuickTableCalcType = api_external_contract_js_2.QuickTableCalcType;
exports.SelectionUpdateType = api_external_contract_js_2.SelectionUpdateType;
exports.SheetSizeBehavior = api_external_contract_js_2.SheetSizeBehavior;
exports.SheetType = api_external_contract_js_2.SheetType;
exports.SortDirection = api_external_contract_js_2.SortDirection;
exports.TableauDialogType = api_external_contract_js_2.TableauDialogType;
exports.TableauEventType = api_external_contract_js_2.EmbeddingTableauEventType;
exports.Toolbar = api_external_contract_js_2.Toolbar;
exports.TrendLineModelType = api_external_contract_js_2.TrendLineModelType;
exports.VizAttributes = api_external_contract_js_2.VizAttributes;
exports.VizAuthoringAttributes = api_external_contract_js_2.VizAuthoringAttributes;
exports.VizSharedAttributes = api_external_contract_js_2.VizSharedAttributes;
exports.WebComponentAttributes = api_external_contract_js_2.WebComponentAttributes;
var TableauAskData_2 = require("./EmbeddingApi/Components/TableauAskData");
exports.TableauAskData = TableauAskData_2.TableauAskData;
var TableauAuthoringViz_2 = require("./EmbeddingApi/Components/TableauAuthoringViz");
exports.TableauAuthoringViz = TableauAuthoringViz_2.TableauAuthoringViz;
var TableauPulse_2 = require("./EmbeddingApi/Components/TableauPulse");
exports.TableauPulse = TableauPulse_2.TableauPulse;
var TableauViz_2 = require("./EmbeddingApi/Components/TableauViz");
exports.TableauViz = TableauViz_2.TableauViz;
//# sourceMappingURL=EmbeddingApi.js.map